import { IRootProps } from '@omni/kit/contexts/types';
import React, { ReactElement } from 'react';

import { NativePropContext } from './NativePropContext';

const debug = require('debug')('tca:search:components:NativePropWrapper.tsx');

export default ({
  props,
  children,
}: {
  props: IRootProps;
  children: ReactElement | ReactElement[] | undefined;
}): ReactElement => {
  debug('context updated', props);

  return (
    <NativePropContext.Provider value={props}>
      {children}
    </NativePropContext.Provider>
  );
};
